import { healthTips } from '@/mocks/homeData';

export default function HealthSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">运动健康</h2>
            <p className="text-sm text-foreground-500 mt-1">科学运动知识，健康生活方式</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {healthTips.map((tip) => (
              <div
                key={tip.id}
                className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-secondary-200 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 flex-shrink-0 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${tip.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-secondary-600 transition-colors">{tip.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-2">{tip.summary}</p>
                  <span className="text-xs text-foreground-400"><i className="ri-time-line mr-1"></i>阅读 {tip.readTime}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}